import CareProfile from '@components/forms/careProfile/CareProfile';
import HandleQuery from '@components/HandleQuery';
import ExpertJourneyPage from '@components/pageTypes/ExpertJourneyPage';
import useGetJourneyWithCareProfileQuery from '@hooks/queries/useGetJourneyWithCareProfileQuery';
import useSubscribeToJourney from '@hooks/subscriptions/useSubscribeToJourney';

type Props = {
  journeyId: string;
};

const ExpertJourneyCareProfilePage = ({ journeyId }: Props) => {
  const getJourneyQuery = useGetJourneyWithCareProfileQuery(journeyId);

  useSubscribeToJourney(journeyId, () => {
    getJourneyQuery.refetch();
  });

  return (
    <ExpertJourneyPage helmetKey="pageTitles.expertJourney.careProfile.show" journeyId={journeyId}>
      <HandleQuery query={getJourneyQuery}>{data => <CareProfile journey={data.journey} />}</HandleQuery>
    </ExpertJourneyPage>
  );
};

export default ExpertJourneyCareProfilePage;
